import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TokenService } from '../_services/token.service';
import { UsersService } from '../_services/users.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {

    constructor(
        private tokenService: TokenService,
        private usersService: UsersService,
        private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

        if (!this.tokenService.hasToken()) {
            this.router.navigate(
                ['/login'],
            );
            return false;
        }

        let roles = route.data.roles as Array<string>;
        let permissions = route.data.permissions as Array<string>;

        if(permissions && permissions.length){
            if (this.hasTokenPermission(permissions)) {
                return true;
            }

            if (roles && roles.indexOf(this.tokenService.profileCode) > -1) {
                return true;
            }

            return this.usersService.getUserId(this.tokenService.id).pipe(
                map(user => this.hasUserPermission(user, permissions)),
                catchError(() => of(false))
            );
        }

        if (roles && roles.length) {
            return roles.indexOf(this.tokenService.profileCode) > -1;
        }

        return true;
    }

    private hasTokenPermission(permissions: Array<string>): boolean {
        return permissions.some(permission => {
            switch (permission) {
                case 'addDriver':
                    return this.tokenService.addDriver;
                default:
                    return false;
            }
        });
    }

    private hasUserPermission(user: any, permissions: Array<string>): boolean {
        return permissions.some(permission => {
            switch (permission) {
                case 'addDriver':
                    return this.toBoolean(user?.addDriver ?? user?.AddDriver);
                default:
                    return false;
            }
        });
    }

    private toBoolean(value: any): boolean {
        return value === true || value === 'true' || value === 'True' || value === 1 || value === '1';
    }
}
